import { Button } from "@/components/ui/button";
import {
  setIsCourseDetails,
  setStartApplication,
} from "@/module/education/stores/educationSlice";

import { ChevronLeft, X } from "lucide-react";
import { useDispatch } from "react-redux";

interface AddApplicationHeaderProps {
  title?: string;
  description?: string;
}

export default function AddApplicationHeader({
  title = "Add Application",
  description = "Create a new parallel option for this lead",
}: AddApplicationHeaderProps) {
  const dispatch = useDispatch();

  const handleBack = () => {
    dispatch(setIsCourseDetails(false));
    dispatch(setStartApplication(false));
  };

  return (
    <div className="bg-white py-5 px-4 sticky top-0 z-10">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            className="flex items-center justify-center rounded-[12px] size-[35px] shrink-0 p-0"
            onClick={handleBack}
          >
            <ChevronLeft
              size={28}
              className="text-[var(--color-black-9)]"
              style={{
                width: "28px",
                height: "28px",
                minWidth: "28px",
                minHeight: "28px",
              }}
            />
          </Button>

          <h4 className="text-b2-mid">{title}</h4>
        </div>
        <X
          className="size-4 text-[var(--color-black-9)] cursor-pointer"
          onClick={handleBack}
        />
      </div>
      <p className="text-b3 text-[var(--color-black-6)] ml-[35px]">
        {description}
      </p>
    </div>
  );
}
